/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NbAuthResult, NbAuthService } from '@nebular/auth';
import { NB_AUTH_OPTIONS } from '../../../../../../node_modules/@nebular/auth/auth.options.js';
import { getDeepFromObject } from '../../helpers';
import { Subscription } from 'rxjs';

@Component({
	selector: 'ngx-reset-password-page',
	templateUrl: './reset-password.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NgxResetPasswordComponent implements OnInit {

	public paramSub: Subscription;

	redirectDelay: number = 0;
	showMessages: any = {};
	strategy: string = '';

	submitted = false;
	errors: string[] = [];
	messages: string[] = [];
	user: any = {
		showPassword: false,
	};

	constructor(
				private route: ActivatedRoute,
				protected service: NbAuthService,
				@Inject(NB_AUTH_OPTIONS) protected options = {},
				protected cd: ChangeDetectorRef,
				protected router: Router,
			) {

		this.redirectDelay = this.getConfigValue('forms.resetPassword.redirectDelay');
		this.showMessages = this.getConfigValue('forms.resetPassword.showMessages');
		this.strategy = this.getConfigValue('forms.resetPassword.strategy');
	}

	ngOnInit(): void {

		this.paramSub = this.route.params.subscribe(params => {
			this.user.resetToken = params['resetToken'];
		});
	}

	resetPass(): void {
		this.errors = this.messages = [];
		this.submitted = true;

		this.service.resetPassword(this.strategy, this.user).subscribe((result: NbAuthResult) => {
			this.submitted = false;
			if (result.isSuccess()) {
				this.messages = result.getMessages();
			} else {
				this.errors = result.getErrors();
			}

			const redirect = result.getRedirect();
			if (redirect) {
				setTimeout(() => {
					return this.router.navigateByUrl(redirect);
				}, this.redirectDelay);
			}
			this.cd.detectChanges();
		});
	}

	getConfigValue(key: string): any {
		return getDeepFromObject(this.options, key, null);
	}
}
